import client from "./client";

export const login = ({ email, password }) =>
  client.post("/user/email/login/", {
    email,
    password,
  });

export const getUsers = (params) =>
  client.get(`/user/`, {
    params
  });

export const getUser = ({ id }) => client.get(`/user/${id}/`);

export const createUser = (params) => client.post(`/user/`, params);

export const editUser = (params) => client.put(`/user/${params.id}/`, params);

export const deleteUsers = ({ selectedItems }) =>
  client.delete(`/user-multi-delete/`, { data: { ids: selectedItems } });


export const getUserGroups = (params) => client.get(`/user-group/?size=1000`);

export const createUserGroups = (params) => client.post(`/user-group/`, params);

export const getCertificates = (params) => {
  return client.get('/certificate/', {
    params
  })
}

export const editCertificates = (params) => {
  return client.put(`/certificate/${params?.id}/`, params)
}

export const deleteCertificates = (params) => {
  return client.delete(`/certificate/${params?.id}/`, params)
}

export const getCertificateTypes = (params) => {
  return client.get('/certificate-type/', {
    params
  })
}
export const getCertificateTypes2 = (params) => {
  return client.get('/certificate-type2/', {
    params
  })
}

export const getCertificateType2 = ({ id }) => client.get(`/certificate-type2/${id}/`);

export const editCertificateType2 = (params) => {
  return client.put(`/certificate-type2/${params?.id}/`, params)
}

export const createCertificateType2 = (params) => {
  return client.post(`/certificate-type2/`, params)
}
export const deleteCertificateType2 = (params) => {
  return client.delete(`/certificate-type2/${params?.id}/`, params)
}


export const editCertificateType = (params) => {
  return client.put(`/certificate-type/${params?.id}/`, params)
}

export const createCertificateType = (params) => {
  return client.post(`/certificate-type/`, params)
}
